import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {
  mobileMenuOpen = false;
  productsDropdownOpen = false;
  servicesDropdownOpen = false;

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  toggleProductsDropdown() {
    this.productsDropdownOpen = !this.productsDropdownOpen;
    this.servicesDropdownOpen = false;
  }

  toggleServicesDropdown() {
    this.servicesDropdownOpen = !this.servicesDropdownOpen;
    this.productsDropdownOpen = false;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  closeDropdowns() {
    this.productsDropdownOpen = false;
    this.servicesDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = target.closest('.dropdown');
    const mobileMenu = target.closest('.mobile-menu');
    const productCard = target.closest('.product-card');
    const serviceCard = target.closest('.service-card');
    const isDesktop = window.innerWidth > 1024;
    
    // No cerrar si es un click en una tarjeta de producto o servicio
    if (productCard || serviceCard) {
      return;
    }
    
    // Solo cerrar dropdowns en desktop si el click es fuera del dropdown
    if (isDesktop && !dropdown && !mobileMenu) {
      this.productsDropdownOpen = false;
      this.servicesDropdownOpen = false;
    }
  }
}
